import React, { useEffect, useState } from 'react';
import { NotificationBanner } from '@cmhc-schl/hearth-ui';
import { UseFormReturn } from 'react-hook-form';
import { UpdateArrearsForm } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/flyout/ArrearsFlyoutContent';
import { useTranslation } from 'react-i18next';

const fieldErrors: Record<string, string> = {
  amount: 'arrearsFlyout.amount',
  institutionNumber: 'arrearsFlyout.institutionNumber',
  transitNumber: 'arrearsFlyout.transitNumber',
  dueDate: 'arrearsFlyout.dueDate'
};

export const ArrearsFlyoutErrorsBanner = ({ form }: { form: UseFormReturn<UpdateArrearsForm> }) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');

  const [isVisible, setVisible] = useState(false);
  const [value, setValue] = useState('');
  const [submitCount, setSubmitCount] = useState(0);

  useEffect(() => {
    setSubmitCount(form.formState.submitCount);

    if (form.formState.submitCount > submitCount && !form.formState.isValid) {
      setVisible(true);

      const errors = Object.entries(form.formState.errors);
      const value =
        errors
          .sort()
          .map(([k, v]) => `<li>${t(fieldErrors[k])}: ${v.message}</li>`)
          .join('') ?? '';
      setValue(value);
    }
  }, [form.formState.submitCount, form.formState.isValid]);
  return (
    <NotificationBanner
      showNotificationBanner={isVisible}
      onCloseNotificationBanner={() => setVisible(false)}
      headerText={{ value: t('arrearsFlyout.errorsBanner.title') }}
      message={{ value }}
      variant={'Error'}
    />
  );
};
